import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// Placeholder copy, pending review.
const RemoveTreatmentDialog = ({ open, treatmentNumber, treatmentLabel, loading = false, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>
      Remove Treatment {treatmentNumber}
      {treatmentLabel ? ` — ${treatmentLabel}` : ''}?
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        This permanently deletes this treatment, including its details and any creatives you uploaded. The remaining
        treatments will be renumbered and the treatment count lowered to match. This can&apos;t be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
        Remove treatment
      </Button>
    </DialogActions>
  </Dialog>
);

export default RemoveTreatmentDialog;
